import { siteConfigSchema } from "./schemas";
import { validateContent } from "./validateContent";

export const siteConfig = validateContent("siteConfig", siteConfigSchema, {
  brandName: "Tech Savvy Starts Here",
  domain: "https://techsavvystartshere.com",
  email: "techsavvystartshere@gmail.com",
  newsletterUrl: "https://newsletter.techsavvystartshere.com/",
  beehiivSubscribeUrl: "https://newsletter.techsavvystartshere.com/subscribe",
  beehiivPublicationUrl: "https://newsletter.techsavvystartshere.com/",
  beehiivEmbedHtml: `<iframe
    src="https://subscribe-forms.beehiiv.com/19e61029-1dda-4227-8f17-06897e49d777"
    title="Tech Savvy Starts Here newsletter signup"
    class="beehiiv-embed"
    data-test-id="beehiiv-embed"
    frameborder="0"
    scrolling="no"
    style="width: 692px; height: 377px; margin: 0; border-radius: 0 !important; background-color: transparent; box-shadow: 0 0 #0000; max-width: 100%;"
  ></iframe>`,
  youtubeUrl: "https://youtube.com/@techsavvystartshere",
  youtubeFeaturedEmbedUrl: "https://www.youtube.com/embed/T8YBCJVEYog",
  youtubePlaylistEmbedUrl: "https://www.youtube.com/embed/videoseries?list=PLgK3zkj90l8mHAjtH9Z_EAeBu4qGOsbvT",
  stripeUrl: "https://buy.stripe.com/9B66oGaDm1bJa4f2850ZW03",
  aiCareerAdvantageStripeUrl: "https://buy.stripe.com/3cI00ifXG1bJdgrbIF0ZW05",
  workshopDate: "",
  workshopTime: "",
  workshopRegistrationUrl: "",
  paymentUrl: "https://buy.stripe.com/9B66oGaDm1bJa4f2850ZW03",
  headshotImage: "/headshot.PNG",
  aiCareerAdvantageMockupImage: "/ai-career-advantage-bundle-mockup.png",
  contactFormEndpoint: "",
  navLinks: [
    { label: "Home", href: "/", external: false },
    { label: "About", href: "/about", external: false },
    { label: "Newsletter", href: "/newsletter", external: false },
    { label: "YouTube", href: "/youtube", external: false },
    { label: "Workshops", href: "/workshops", external: false },
    { label: "Career Bundle", href: "/ai-career-advantage", external: false },
    { label: "Contact", href: "/contact", external: false },
  ],
  footerLinks: [
    { label: "Home", href: "/", external: false },
    { label: "About", href: "/about", external: false },
    { label: "Newsletter", href: "/newsletter", external: false },
    { label: "YouTube", href: "/youtube", external: false },
    { label: "Workshops", href: "/workshops", external: false },
    { label: "Career Bundle", href: "/ai-career-advantage", external: false },
    { label: "Contact", href: "/contact", external: false },
  ],
  footerTagline: "Practical AI and digital skills for real life",
  navPrimaryCta: {
    label: "Subscribe",
    href: "/newsletter",
    external: false,
  },
  navSecondaryCta: {
    label: "Workshop Updates",
    href: "/workshops",
    external: false,
  },
  socialLinks: [
    {
      label: "YouTube",
      href: "https://youtube.com/@techsavvystartshere",
      icon: "Youtube",
    },
    {
      label: "Newsletter",
      href: "https://newsletter.techsavvystartshere.com/",
      icon: "Mail",
    },
  ],
});
